<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16.942" height="9.79" viewBox="0 0 16.942 9.79">
    <g id="Gruppe_37" data-name="Gruppe 37" transform="translate(-212.27 512.106) rotate(-90)">
      <line id="Linie_8" data-name="Linie 8" x1="7.896" y2="8.422" transform="translate(503.263 220.106)" fill="none" stroke="#fff" stroke-width="2"/>
      <line id="Linie_9" data-name="Linie 9" x1="7.896" y2="8.422" transform="translate(511.422 213) rotate(90)" fill="none" stroke="#fff" stroke-width="2"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "chevron_up"
}
</script>

<style scoped>

</style>